import Tab from "../bootstrap/tab";

export const winnerTable = () => {

	const tabSelect = document.getElementById('tabSelect');
	if (!tabSelect) {
		return;
	}
	const tabButtons = document.querySelectorAll('#myTab button[data-bs-toggle="tab"]');
	const tabItems = document.querySelectorAll('#myTab .nav-item');

	function activateTab(tabId) {
		const tabTriggerEl = document.querySelector(`#${tabId}-tab`);
		const tab = new Tab(tabTriggerEl);
		tab.show();
	}

	function updateSelect(tabId) {
		tabSelect.value = tabId;
	}

	function updateNavItemClass() {
		tabItems.forEach(item => {
			item.classList.remove('active-tab');
			item.querySelector('.nav-link').classList.remove('active');
		});
		const activeButton = document.querySelector(`#${tabSelect.value}-tab`);
		activeButton.classList.add('active');
		activeButton.closest('.nav-item').classList.add('active-tab');
	}

// Update the tab when the select element changes
	tabSelect.addEventListener('change', function () {
		activateTab(this.value);
		updateNavItemClass();
	});

// Update the select element and nav-item class when the tab changes
	tabButtons.forEach(button => {
		button.addEventListener('shown.bs.tab', function (event) {
			const selectedTabId = event.target.id.replace('-tab', '');
			updateSelect(selectedTabId);
			updateNavItemClass();
		});
	});

// Initial setting of the active class on load
	document.addEventListener('DOMContentLoaded', updateNavItemClass);
}
